<template>
	<div class="takephoto" :style="{ height: `${windowHeight}px`, 'overflow-y': 'scroll' }">
		<el-row>
			<table class="htmltable">
				<tr>
					<td rowspan="2">
						<el-card class="box-card">
							<div slot="header" class="clearfix">
								<span>拍照</span>
								<label for>
									<el-checkbox v-model="sendremind" :true-label="1" :false-label="0" style="transform: scale(1.1);margin-left:55px;">发送提醒</el-checkbox>
								</label>
							</div>
							<table>
								<tr class="b_font">
									<td><el-input ref="pkval" v-model="pkval" placeholder="请输入单号" @keyup.enter.native="enterinput('pkval')"></el-input></td>
									<td><el-input ref="code" v-model="code" placeholder="请输入指令" @keyup.enter.native="enterinput('code')"></el-input></td>
								</tr>
								<tr>
									<td colspan="2"><video id="videoCamera" :width="videoWidth" :height="videoHeight" autoplay></video></td>
								</tr>
								<tr>
									<td colspan="2" style="text-align:center;">
										<span class="takephotobtn" @click="savephotoimage">拍 照</span>
										<span class="takephotobtn graybtn" @click="closetakephoto">返 回</span>
										<span class="takephotobtn bluebtn" @click="downphoto">下 载</span>
									</td>
								</tr>
							</table>

							<canvas style="display:none;" id="canvasCamera" :width="videoWidth" :height="videoHeight"></canvas>
						</el-card>
					</td>
					<td>
						<el-card class="box-card">
							<div slot="header" class="clearfix"><span>历史照片</span> <span style="margin-left:10px">共 {{historyurls.length}} 张</span></div>
							<div :style="{ height: `${historyheight}`, 'overflow-y': 'auto' }">
								<el-card class="box-card" shadow="never" v-for="(item, index) in historyurls" :key="index">
									<div slot="header" class="clearfix">
										<div class="headtitle">
											<label>拍摄人：{{item.u_account}} </label>  <label>时间：{{item.u_createtime}}</label><label>
											<i class="el-icon-delete Danger" title="删除" @click="delimage(item,index)"></i></label>
										</div>
									</div>
									<el-image :src="item.src" style="width:100%"></el-image>
								</el-card>
								<div v-if="historyurls.length==0" class="urlempty">
									<span>无拍照记录</span>
								</div>
							</div>
						</el-card>
					</td>
				</tr>
			</table>
		</el-row>
	</div>
</template>
<script>
import Utils from '../../lib/util.js';
export default {
	props: {
		urlparam: {
			syscode: String,
			default: ''
		}
	},
	data() {
		return {
			pkval: '',
			windowHeight: (window.innerHeight * 88) / 100,
			videoWidth: 600,
			videoHeight: 400,
			historyheight: '535px',
			divclass: 'takephoto',
			historyurls: [], //历史图片
			thisCancas: null,
			thisContext: null,
			thisVideo: null,
			code: '',
			orderinfo:{},
			sendremind:0,
			p_remark:'已拍照',
			syscode:''
		};
	},
	mounted() {
		this.$apipost.get.getTheme().then(res => {
			import('../../static/' + res + '/style/wm/takephoto.scss');
		});
		var that=this;
		this.$nextTick(function() {
			that.init();
		});
		if(this.urlparam!=undefined){
			if(this.urlparam.syscode!=undefined)
				this.syscode=this.urlparam.syscode;
		}
	},
	beforeDestroy(){
		this.thisVideo.srcObject.getTracks()[0].stop();
	},
	methods: {
		init(param) {
			this.$tool.loading('正在打开摄像头', this.divclass);
			this.thisVideo = document.getElementById('videoCamera');
			this.thisCancas = document.getElementById('canvasCamera');
			this.thisContext = this.thisCancas.getContext('2d');
			this.getCompetence();
		},
		getCompetence() {
			if (navigator.mediaDevices.getUserMedia || navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia) {
				//调用用户媒体设备, 访问摄像头
				this.getUserMedia(
					{
						video: {
							width: this.videoWidth,
							height: this.videoHeight
						}
					},
					this.success,
					this.error
				);
			} else {
				//alert('不支持访问用户媒体');
				this.$tool.ReadMsg('打开摄像头失败');
				this.$tool.message('不支持访问用户媒体',0);
			}
		},
		getUserMedia(constraints, success, error) {
			if (navigator.mediaDevices.getUserMedia) {
				//最新的标准API
				navigator.mediaDevices
					.getUserMedia(constraints)
					.then(success)
					.catch(error);
			} else if (navigator.webkitGetUserMedia) {
				//webkit核心浏览器
				navigator.webkitGetUserMedia(constraints, success, error);
			} else if (navigator.mozGetUserMedia) {
				//firfox浏览器
				navigator.mozGetUserMedia(constraints, success, error);
			} else if (navigator.getUserMedia) {
				//旧版API
				navigator.getUserMedia(constraints, success, error);
			}
		},
		success(stream) {
			//兼容webkit核心浏览器
			let CompatibleURL = window.URL || window.webkitURL;
			//将视频流设置为video元素的源
			this.thisVideo.srcObject = stream;
			this.thisVideo.play();
			this.$tool.loadingclose();
			this.$refs.pkval.focus();
		},
		error(error) {
			 this.$tool.message('访问用户媒体设备失败',0);
			 this.$tool.ReadMsg('打开摄像头失败');
		},
		//保存拍照
		savephotoimage() {
			//debugger
			if(this.pkval.trim()!=''){
				// 点击，canvas画图
				this.thisContext.drawImage(this.thisVideo, 0, 0, this.videoWidth,this.videoHeight);
				// 获取图片base64链接
				var image = this.thisCancas.toDataURL('image/png');
				if(image!=''){
					//保存图片，添加图片到列表
					this.savephoto(image);
				}else{
					that.$tool.ReadMsg('拍照失败');
				}
			}
			else
				this.$refs.pkval.focus();
		},
		closetakephoto() {
			this.thisVideo.srcObject.getTracks()[0].stop();
			Utils.$emit('handleRermove', localStorage.getItem('tabname'));
		},
		enterinput(control){
			if(control=='pkval'){
				this.pkval=this.pkval.trim();
				if(this.pkval!=''){
					this.$refs.code.focus();
					this.getphotolist();
				}
			}
			if(control=='code'){
				var code=this.code.trim().toLocaleLowerCase();
				if(code=='1a')//拍照
					this.savephotoimage();
				else if(code=="1b"){
					this.pkval='';
					this.code='';
					this.historyurls=[];
					this.$refs.pkval.focus();
				}
			}
		},
		getphotolist(){
			var that=this;
			if(this.pkval.trim()!=''){
				that.historyurls=[];
				this.$tool.loading('正在读取照片', this.divclass);
				this.$apipost.get.GetPhoto({pkval:this.pkval.trim()}).then(res => {
					this.$tool.loadingclose();
					if(res.list!=undefined)
						that.historyurls=res.list;
				});
			}
		},
		//保存照片
		savephoto(image){
			var that=this;
			var paraminfo={
				syscode:this.syscode,
				image:encodeURIComponent(image),
				pkval:this.pkval.trim(),
				userid:localStorage.getItem('userid'),
				u_account:localStorage.getItem('u_account'),
				u_name:localStorage.getItem('u_name')
			}
			this.code='';
			this.$tool.loading('正在保存照片', this.divclass);
			this.$apipost.post.SavePhoto({paraminfo:paraminfo}).then(res => {
				this.$tool.loadingclose();
				if(res.state=='1'){
					that.historyurls.splice(0, 0, { filename:res.filename, src: image,u_account:res.u_account,u_createtime:res.u_createtime });
					that.$tool.ReadMsg('成功');
					if(that.sendremind=='1')
						that.$tool.SendMessage(
						{msgid:'285-1',info:that._data,pkval:this.pkval,type:'4-q',showerror:false},that);
				}
				else{
					that.$tool.ReadMsg('失败');
				}
			});
		},
		//移除照片
		delimage(item,index){
			var that=this;
			this.$tool.loading('正在删除', this.divclass);
			this.$apipost.post.DelPhoto({filename:item.filename}).then(res => {
				this.$tool.loadingclose();
				if(res.state=='1'){
					that.historyurls.splice(index, 1);
					that.$tool.message('删除成功',1);
				}
				else{
					that.$tool.message('删除失败',0);
				}
			});
		},
		//下载照片
		downphoto(){
			var that=this;
			this.$tool.loading('正在下载', this.divclass);
			this.$apipost.get.DownPhoto({pkval:this.pkval.trim(),syscode:this.syscode}).then(res => {
				this.$tool.loadingclose();
				if(res.state=='1'){
					if(res.filename!=undefined)
						that.$tool.downfile(that,res.filename);
					that.$tool.message('下载成功',1);
				}
				else{
					that.$tool.message('下载失败',0);
				}
			});
		}
	}
};
</script>
